import FollowUpCRUDActions from '../actions/FollowUpCRUDActions';
import Actions from '../actions/actions';
import { groupBy, forEach } from 'lodash';
import { setBusy, setUnBusy } from './common/commonReducers';
import { FollowUpsState } from '../interfaces/followUps';
import {
  FollowUpKind,
  FollowUpModel,
  QqFollowUpModel,
  entityTypeByKind,
} from '../model/FollowUpModel';

const initialState: FollowUpsState = {
  busy: false,
  entities: {
    resolvedFollowUps: [],
    pendingFollowUps: [],
    qqFollowUps: [],
  },
};

const update = (
  state: FollowUpsState,
  action: { entity: FollowUpModel<QqFollowUpModel> },
) => {
  const { kind } = action.entity;
  const entities = [...state.entities[entityTypeByKind[kind]]];
  const entityIndex = entities.findIndex(e => e.id === action.entity.id);
  if (entityIndex === -1) {
    entities.push(action.entity);
  } else {
    entities[entityIndex] = action.entity;
  }
  return {
    ...state,
    busy: false,
    entities: { ...state.entities, [entityTypeByKind[kind]]: entities },
  };
};

const retrievedAll = (
  state: FollowUpsState,
  action: { entities: FollowUpModel<QqFollowUpModel>[] },
) => {
  const { entities } = action;
  const newState: Partial<FollowUpsState['entities']> = {
    ...initialState.entities,
  };
  const grouped = groupBy(entities, 'kind');
  forEach(
    grouped,
    (value: FollowUpModel<QqFollowUpModel>[], kind: FollowUpKind) => {
      newState[entityTypeByKind[kind]] = value;
    },
  );
  return {
    ...state,
    busy: false,
    entities: newState,
  };
};

const retrievedByKind = (
  state: FollowUpsState,
  action: { entities: FollowUpModel<QqFollowUpModel>[]; kind: FollowUpKind },
) => {
  const { entities, kind } = action;
  return {
    ...state,
    busy: false,
    entities: { ...state.entities, [entityTypeByKind[kind]]: entities },
  };
};

export function followUps(state = initialState, action: any) {
  switch (action.type) {
    case FollowUpCRUDActions.busyAction:
      return setBusy(state);
    case FollowUpCRUDActions.unbusyAction:
      return setUnBusy(state);
    case FollowUpCRUDActions.retrievedAllAction:
      return retrievedAll(state, action);
    case FollowUpCRUDActions.retrievedByKindAction:
      return retrievedByKind(state, action);
    case FollowUpCRUDActions.updateAction:
      return update(state, action);
    case Actions.RESET:
    case FollowUpCRUDActions.resetAction:
      return initialState;
    case Actions.UNBUSY:
      return { ...state, busy: false };
    default:
      return state;
  }
}
